"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 0.5rem;\n"])));

var successStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorSuccess;
}, function (p) {
  return p.theme.colorSuccessText;
});
var dangerStyles = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorDanger;
}, function (p) {
  return p.theme.colorDangerText;
});

var StyledButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  height: 50px;\n  padding: 0;\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.isSelected ? p.theme.colorPickemButtonBackgroundActive || p.theme.colorAccent : p.theme.colorPickemButtonBackground || p.theme.colorLightGrey;
}, function (p) {
  return p.isSelected ? p.theme.colorPickemButtonTextActive || p.theme.colorAccentText : p.theme.colorPickemButtonText || p.theme.colorText;
}, function (p) {
  return !p.isSelected && "background: ".concat(p.theme.colorDisabledBackground, "; color: ").concat(p.theme.colorDisabledText, ";");
}, function (p) {
  return p.isSuccess && successStyles;
}, function (p) {
  return p.isDanger && dangerStyles;
});

var StyledLockIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  font-size: 20px;\n  transform: translateY(-50%);\n"])));

var ContestPicksButtons = function ContestPicksButtons(_ref) {
  var translations = _ref.translations,
      betbarParent = _ref.betbarParent,
      questionId = _ref.questionId,
      questionOptions = _ref.questionOptions,
      updatePicks = _ref.updatePicks,
      correctAnswerId = _ref.correctAnswerId,
      myAnswerId = _ref.myAnswerId,
      isLocked = _ref.isLocked,
      showIcon = _ref.showIcon;
  var hadBet = betbarParent.hadBet;

  var _onClick = function onClick(pickId, option) {
    updatePicks(pickId, option);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: questionOptions.map(function (option) {
      var isRight = option.points > 0;
      var isAnswerRight = correctAnswerId === myAnswerId;
      var isWrong = !isRight;
      var isAnswerWrong = !isAnswerRight;
      var isSelected = myAnswerId === option.id;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
        disabled: isLocked,
        isSuccess: hadBet && isLocked && showIcon && isRight && isAnswerRight,
        isDanger: hadBet && isLocked && showIcon && isWrong && isSelected,
        isSelected: isSelected,
        onClick: function onClick() {
          return _onClick(questionId, option);
        },
        children: [option.label === "Yes" ? translations.yes : option.label === "No" ? translations.no : option.label, isSelected && (showIcon || isLocked) && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockIcon, {
          children: showIcon && isRight && isAnswerRight ? "check" : showIcon && isWrong ? "close" : "lock"
        })]
      });
    })
  });
};

var _default = ContestPicksButtons;
exports.default = _default;